<div class="font-primary flex min-h-screen flex-col">
    <app-header-client [pageTitle]="pageTitle()" />
    <div class="h-[90px] shrink-0"></div>

    <main class="flex-1 px-4 sm:px-6 lg:px-8">
        <div class="mx-auto max-w-[96rem]">
            <ng-content></ng-content>
        </div>
    </main>

    <app-footer-client />
</div>
